import type { PropsWithChildren } from "react";

import { PDFConfigProvider } from "@alaffia-technology-solutions/pdf-viewer";

interface PdfViewerProviderProps extends PropsWithChildren {
  baseUrl: string;
  foxitLicenseKey: string;
  foxitLicenseSN: string;
}

export const PdfViewerProvider = ({
  baseUrl,
  foxitLicenseKey,
  foxitLicenseSN,
  children,
}: PdfViewerProviderProps) => {
  return (
    <PDFConfigProvider
      jrConfig={{
        enginePath: "./jr-engine/gsdk",
        fontPath: `${baseUrl}/foxit/external/brotli`,
        fontInfoPath: `${baseUrl}/foxit/external/brotli/fontInfo.csv`,
        licenseKey: foxitLicenseKey,
        licenseSN: foxitLicenseSN,
        workerPath: `${baseUrl}/foxit/lib/`,
      }}
      libPath="/foxit/lib"
    >
      {children}
    </PDFConfigProvider>
  );
};
